function deletePeriodProperties(filter) {
	delete filter.calendarId
	delete filter.periodId1
	delete filter.periodId2
	delete filter.periodDelta1
	delete filter.periodDelta2
}

function deleteDateProperties(filter) {
	delete filter.date1
	delete filter.date2
}

function deleteTimeProperties(filter) {
	delete filter.time1
	delete filter.time2
}

function deleteDateTimeProperties(filter) {
	delete filter.dateTime1
	delete filter.dateTime2
}

/**
 * @param filter {Object}
 * @param chooseByVal { 'calendar-period' | 'day' | 'time', 'date-time' | undefined }
 */
function deleteNonApplicableFilterProperties(filter, chooseByVal = undefined) {
	if (chooseByVal !== 'calendar-period') {
		deletePeriodProperties(filter)
	}

	if (chooseByVal !== 'day') {
		deleteDateProperties(filter)
	}

	if (chooseByVal !== 'time') {
		deleteTimeProperties(filter)
	}

	if (chooseByVal !== 'date-time') {
		deleteDateTimeProperties(filter)
	}

	if (filter.updateType1 === 'manual') {
		delete filter.equation1
	} else if (filter.updateType1 === 'calculated') {
		delete filter.date1
		delete filter.time1
		delete filter.dateTime1
	}

	if (filter.updateType2 === 'manual') {
		delete filter.equation2
	} else if (filter.updateType2 === 'calculated') {
		delete filter.date2
		delete filter.time2
		delete filter.dateTime2
	}

	if (filter.operator === 'at-any-time' || filter.operator === 'on-any-date') {
		delete filter.updateType1
		delete filter.updateType2
		deletePeriodProperties(filter)
		deleteDateProperties(filter)
		deleteTimeProperties(filter)
		deleteDateTimeProperties(filter)
	} else {
		delete filter.equations
	}

	if (filter.operator !== 'at-any-time') {
		delete filter.times
	}

	if (filter.operator !== 'on-any-date') {
		delete filter.dates
	}


}

export default deleteNonApplicableFilterProperties
deleteNonApplicableFilterProperties.__filename__ = 'datasets/filters/delete-non-applicable-filter-properties.js'
